export const validateUser = (required, has) => {
  let validate = required.some(v => has.includes(v));
  console.log("req: " + required + " has: " + has);
  if (!validate) {
    alert("You do not have the necessary permissions to view this page");
    window.history.back();
  }
};

// Function to check required permissions against user permissions.  Returns true or false.
export const checkPermissions = (permissions, required) => {
  return required.some(item => permissions.indexOf(item) !== -1);
};

const accessPermissions = [
  { value: "ADMIN_PANEL", label: "Can access admin panel" }
];

const userPermissions = [
  { value: "VIEW_USERS", label: "Can view users" },
  { value: "EDIT_USERS", label: "Can edit users" },
  { value: "CREATE_USERS", label: "Can create users" },
  { value: "DELETE_USERS", label: "Can delete users" },
  { value: "VIEW_USER_GROUPS", label: "View user groups" },
  { value: "EDIT_USER_GROUPS", label: "Edit user groups" },
  { value: "CREATE_USER_GROUPS", label: "Create user groups" }
];


const paymentPermissions = [
  { value: "VIEW_PAYMENTS", label: "Can view users" },
  { value: "EDIT_PAYMENTS", label: "Can edit users" },
  { value: "CREATE_PAYMENTS", label: "Can create users" },
  { value: "DELETE_PAYMENTS", label: "Can delete users" }
];


const blogPermissions = [
  { value: "CREATE_ARTICLE", label: "Can create blog articles" },
  { value: "DELETE_ARTICLE", label: "Can delete blog articles" }
];

const permissions = [
  {
    name: "Access Permissions",
    options: [...accessPermissions]
  },
  {
    name: "User Permissions",
    options: [...userPermissions]
  },
  {
    name: "Blog Permissions",
    options: [...blogPermissions]
  },
  {
    name: "Payment Permissions",
    options: [...paymentPermissions]
  },
];

export default permissions;



// WEBPACK FOOTER //
// ./src/system/utils/UserPermissions.js